<template>
    <div class="layout-aside-content">
        <!-- 左侧导航内容 -->
        <div class="layout-aside-header">
            <img class="layout-aside-logo" src="@/assets/logo.png" alt="logo">
            <span class="layout-aside-title" :class="{ 'is-hidden': isCollapse }">杭小漂</span>
        </div>
        <div class="layout-aside-menu">
            <el-menu :default-active="activeMenu" background-color="#011E4A" text-color="#ffffff"
                active-text-color="#00D4C8" :collapse="isCollapse" :collapse-transition="false" router>
                <!-- 首页（固定项，不在后端菜单中） -->
                <el-menu-item index="/home">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">首页</span>
                </el-menu-item>
                <!-- 动态菜单：从 vuex 中的 menus 渲染 -->
                <sidebar-item
                    v-for="item in menuList"
                    :key="item.id || item.path"
                    :item="item"
                    :is-collapse="isCollapse"
                />
            </el-menu>
        </div>
    </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'

export default {
    name: 'LayoutAside',
    components: {
        SidebarItem
    },
    props: {
        isCollapse: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 从 vuex 获取菜单树，侧边栏只显示 type=10（菜单）节点
        // type=20（子页面，如编辑页）不显示在侧边栏；type=30（按钮）后端已过滤
        menuList() {
            const menus = this.$store.state.user.menus || []
            return menus.filter(item => item.type === 10)
        },
        activeMenu() {
            return this.$route.path
        }
    }
}
</script>

<style lang="less">
.layout-aside-content {
    width: 100%;
    height: 100%;

    .layout-aside-header {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 55px;
        overflow: hidden;
    }

    .layout-aside-logo {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
    }

    .layout-aside-title {
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
        white-space: nowrap;
        transition: opacity 0.2s;

        &.is-hidden {
            // 用 opacity 而非 display:none，避免折叠瞬间布局抖动
            opacity: 0;
            width: 0;
            margin-left: 0;
            overflow: hidden;
        }
    }

    .layout-aside-menu {
        height: calc(100% - 55px);
        overflow-y: auto;
    }
}
</style>
